import map from "@components/map";
import CustomIcon from "./customIcon";
import AnalyticsTracking from "@helpers/analyticsTracking";
import { defaults } from "@helpers/defaults";
import CheckHideItems from "./checkBigcreenIcon";

const zoomLevelDefault = Math.floor(map.getZoom());
const checkIfTypeSiteIsBackend =
  HQ.Properties.typeSite === "backend" ? true : false;

// https://gist.github.com/up209d/4c68f2391f2302e510eb81aa8bcd4514
// leaflet.forceZIndex.js
(function (global) {
  var MarkerMixin = {
    _updateZIndex: function (offset) {
      // https://gist.github.com/up209d/4c68f2391f2302e510eb81aa8bcd4514?permalink_comment_id=4538042#gistcomment-4538042
      // offset at relative value, or put absolute zIndex value with forceZIndex
      this._icon.style.zIndex = isNaN(this.options.forceZIndex) // any no-numeric = unassigned. 0 is ok for the forceZIndex
        ? this._zIndex + offset
        : this.options.forceZIndex + (this.options.zIndexOffset || 0);
    },
    setForceZIndex: function (forceZIndex) {
      this.options.forceZIndex = forceZIndex ? forceZIndex : null;
    },
  };
  if (global) global.include(MarkerMixin);
})(L.Marker);

/**
 * Add icons to map
 * @param {object} arrayPlaces
 */
export default function AddIconsToMap(arrayPlaces) {
  arrayPlaces.map(({ id, icon, children }) => {
    let layerName = icon?.replace(/icon-/g, "");

    const layerNameWithId = `${layerName}-${id}`;

    window[layerNameWithId] = L.featureGroup().addTo(map);

    if (checkIfTypeSiteIsBackend) {
      window[layerNameWithId].addTo(map);
    }

    // ----------------------------------------------------

    // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/641
    // prevent add icons to map when bigscreen mode is active
    // and has hideItems query string

    // if (CheckHideItems({ id, arrayPlaces, typePlace: "iconOnMap" })) {
    //   children = [];
    // }

    // ----------------------------------------------------

    children.map(
      ({
        id,
        name,
        name_tracking,
        hole,
        icon,
        html,
        image,
        video,
        description,
        icon_shortcode,
        latitude,
        longitude,
        area,
        orderby,
        color,
        color_front,
        zoom_levels,
        color_outline,
        partner,
      }) => {
        let popupContent;
        let options;

        // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/645
        // if icon is icon-branded-content and partner (turnament) exist then
        // change icon to partner icon partner.icon
        icon =
          icon === "icon-branded-content" && partner?.icon
            ? partner.icon
            : icon;

        // -----------------------------------------------

        const partnerName = partner ? { partner: partner["name"] } : "";

        // console.log("id", id);
        const checkIfZoomLevelIsInArray =
          zoom_levels.includes(zoomLevelDefault);
        // console.log(checkIfZoomLevelIsInArray);

        const showIDIfSuperAdmin = HQ.Properties.userType ? ` (${id})` : "";

        if (icon === "icon-hole") {
          // console.log(icon, html);

          if (html) {
            popupContent = html;
          } else {
            let { avg_score, metres, no, par, yards } = hole;

            avg_score = avg_score
              ? `<div class="hole-info-avg">Avg. score: ${avg_score}</div>`
              : "";

            const htmlData = html
              ? `<div class="hole-info-html pb-2">${html}</div>`
              : "";

            popupContent = `
            <div class="hole-info">
              ${htmlData}
              <div class="hole-info-par">
                <h3 class="card-title">${HQ.Properties.i18n["popupContent"]["hole"]} ${no}${showIDIfSuperAdmin}</h3>
                <span class="card-text">PAR ${par}</span>
              </div>
              <div class="hole-info-units">
                <span class="hole-unit-meter">${metres}m</span>
                <span class="hole-unit-delimiter px-1">/</span>
                <span class="hole-unit-yards">${yards}y</span></div>
              ${avg_score}
            </div>
          `;
          }
        } else if (icon === "icon-twitter" || icon === "icon-x") {
          options = { minWidth: 319, maxWidth: 319 };
          popupContent = `${html}${showIDIfSuperAdmin}`;
        } else {
          if (html) {
            popupContent = html;
            options = { minWidth: 240 };
          } else if (description) {
            options = { minWidth: 240 };
            popupContent = `
              <div class="card card-leaflet">
                <div class="card-body">
                  <h3 class="card-title">${name}${showIDIfSuperAdmin}</h3>
                  <div class="card-text mt-1">${description}</div>
                </div>
              </div>
            `;
          } else {
            options = "";
            popupContent = `<h3 class="card-title">${name}${showIDIfSuperAdmin}</h3>`;
          }
        }

        // show_social_buttons = show_social_buttons?.match(
        //   /<!-- SOCIAL_BUTTONS_PLACES -->/g
        // );

        // if (id === 45) {
        //   console.log(id, show_social_buttons, options);
        //   console.log("show_social_buttons", show_social_buttons);
        // }

        // set width popup depence on image or video exist
        options = image || video ? { minWidth: 281, maxWidth: 281 } : options;

        // console.log(id, icon, options);

        if (latitude) {
          const contentDescription =
            icon === "icon-hole"
              ? {
                  content: icon_shortcode,
                  iconConfig: defaults.iconSize,
                }
              : { content: icon_shortcode };

          // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/762
          // check if latitude and longitude is a number
          if (isNaN(latitude) || isNaN(longitude)) {
            console.error(`${name} place with incorrect lat,lng config`);
            return;
          }

          window[`marker-${id}`] = L.marker([latitude, longitude], {
            icon: CustomIcon({
              id,
              icon,
              ...contentDescription,
              color,
              color_front,
              color_outline,
              partner,
            }),
            forceZIndex: -orderby,
          })
            .bindPopup(popupContent, options)
            .on("click", function (e) {
              const clickType =
                icon == "icon-video" ||
                icon == "icon-picture" ||
                icon == "icon-twitter" ||
                icon == "icon-x"
                  ? "Highlight"
                  : "Place";
              AnalyticsTracking(`click${clickType}`, {
                name: name_tracking,
                icon,
                icon_shortcode,
                description,
                ...partnerName,
              });
            });
          // NOTE: temporary off
          // .on("popupopen", function (e) {
          //   let px = map.project(e.popup._latlng);
          //   px.y -= e.popup._container.clientHeight / 2;
          //   map.panTo(map.unproject(px));
          //   console.log("one");
          // });

          // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/373
          // set zIndex depence on orderby
          // zIndexChange(orderby, latitude, longitude, id);

          // window[`marker-${id}`].setForceZIndex(-orderby);

          // check if zoom_levels contains
          // the current zoom level on map
          // if true add all icon to the map
          if (checkIfZoomLevelIsInArray) {
            // if crawler exist show only one place (twslider-wrapperitter - highlights)
            if (HQ.Properties.isSocialMediaBot) {
              // if id === placeID then show this highlights
              if (id == placeID) {
                window[`marker-${id}`].addTo(window[layerNameWithId]);
              } else if (icon !== "icon-video") {
                // show all icons except icon-video
                window[`marker-${id}`].addTo(window[layerNameWithId]);
              }
            } else {
              window[`marker-${id}`].addTo(window[layerNameWithId]);
            }
          }

          if (checkIfTypeSiteIsBackend) {
            window[`marker-${id}`].addTo(window[layerNameWithId]);
          }
        }

        if (area) {
          addAreaToLayer({
            checkIfZoomLevelIsInArray,
            area,
            layerNameWithId,
            id,
            options,
            name_tracking,
            icon,
            icon_shortcode,
            description,
            popupContent,
          });
        }
      }
    );
  });
}

/**
 * Add area to layer
 *
 * @param {object} param
 */
function addAreaToLayer({
  checkIfZoomLevelIsInArray,
  area,
  layerNameWithId,
  id,
  options,
  name_tracking,
  icon,
  icon_shortcode,
  description,
  popupContent,
}) {
  window[`area-${id}`] = geoJSONLayer({
    id,
    name: name_tracking,
    icon,
    options,
    icon_shortcode,
    description,
    area: JSON.parse(area),
    popupContent,
  });
  // check if zoom_levels contains
  // the current zoom level on map
  // if true add all polygon to the map
  if (checkIfZoomLevelIsInArray) {
    window[`area-${id}`].addTo(window[layerNameWithId]);
  }

  if (checkIfTypeSiteIsBackend) {
    window[`area-${id}`].addTo(window[layerNameWithId]);
  }
}

/**
 * Add layer geoJSON to layer
 *
 * @param {object} param
 * @returns geoJSON
 */
function geoJSONLayer({
  id,
  name,
  icon,
  options,
  icon_shortcode,
  description,
  area,
  popupContent,
  color = "#1E88E5",
}) {
  const dashArray = icon === "icon-hole" && area ? 3 : 0;

  const geoJsonLayers = L.geoJSON(area, {
    style: function (feature) {
      color =
        icon === "icon-hole" && area
          ? feature.properties.color || "#ffffff"
          : feature.properties.color || color;
      return {
        color,
        weight: 2,
        dashArray,
        fillOpacity: feature.properties.fillOpacity || 1,
        className: id ? `place-${id}` : "",
      };
    },
    onEachFeature: function (feature, layer) {
      layer.on("click", function (e) {
        AnalyticsTracking("clickPlace", {
          name,
          icon,
          icon_shortcode,
          description,
        });
      });
    },
  }).bindPopup(popupContent, options);

  if (checkIfTypeSiteIsBackend) {
    geoJsonLayers.addTo(map);
  }

  return geoJsonLayers;
}

/**
 * The change of zIndex depends on the orderby variable
 *
 * @param {Number} orderby
 * @param {Number} lat
 * @param {Number} lng
 * @param {Number} markerId
 */
function zIndexChange(orderby, lat, lng, markerId) {
  const pos = map.latLngToLayerPoint(new L.latLng(lat, lng)).round();

  const removeDefaultzIndex = pos.y < 0 ? pos.y : -pos.y;
  window[`marker-${markerId}`].setZIndexOffset(
    removeDefaultzIndex + 300 - orderby
  );
}
